<template lang="pug">
eventengine
  //- hide for worldcup
  template(v-if="wcMode")
    #new-ui.modal.modal-common.fade(tabindex='-1' role='dialog' aria-labelledby='new-ui' aria-hidden='true')
      .modal-dialog.modal-dialog-centered(role='document')
        .modal-content
          .btn-close(data-dismiss='modal' aria-label='Close')
            i.fas.fa-times-circle
          .modal-body.p-0
            .modern-view-banner-wrap
              img.modern-view-banner.img-fluid(:src='fifaCampaignBannerImage' @click='openFifaCampaignBanner')
              //- glassTimer(
              //-   v-if='showGlassTimer'
              //-   :seconds='5'
              //-   @complete='onGlassTimerComplete'
              //- )
          //- .btn-wrapper
          //-   .btn-modern(@click='changeView("modern")')
          //-     img(src='images/sparkles.svg')
          //-     |  {{ $t("ui.modern_view") }} 
  #uuslot-promo.modal.modal-common.fade(tabindex='-1' role='dialog' aria-labelledby='uuslot-promo' aria-hidden='true')
    .modal-dialog.modal-dialog-centered(role='document')
      .modal-content
        .btn-close(data-dismiss='modal' aria-label='Close')
          i.fas.fa-times-circle
        .modal-body.p-0
          iframe.promo-frame(
            v-if='showUuslotPromoFrame'
            :src='uuslotPromoUrl'
            title='9th Anniversary'
          )
  .new-ui-fullscreen-loading(v-if='changingToModern')
    .new-ui-switch-inner
      i.fad.fa-spinner.fa-spin.new-ui-switch-spinner
      p.new-ui-switch-text {{ $t("ui.switching_to_modern_view") }}
  floating
  minigamesModal
  betSingleModal
  betSingleStatus
  betParlayModal
  betParlayStatus
  //- betResultModal
  betSingleMMOModal
  betSingleMMOStatus
  betParlayMMOModal
  betParlayMMOStatus
  searchModal
  timeMachineModal
  //- leagueModal
  nicknameModal
  passwordModal
  languageModal
  allSportsModal
  oddsTypeModal
  defaultEventSortingModal
  drawer
  //- template(v-if="!whiteLabel && !mmoMode")
  //-   .minigame-nav(data-toggle='modal' data-target='#minigame')
  //-     img(src='images/floating_minigame.png')
  router-view
  topButton
</template>

<script>
import config from "@/config";
import eventengine from "@/components/eventEngine";
import floating from "@/components/mobile/floating";

import betSingleModal from "@/components/mobile/bets/new/betSingleModal";
import betSingleStatus from "@/components/mobile/bets/new/betSingleStatus";
import betParlayModal from "@/components/mobile/bets/new/betParlayModal";
import betParlayStatus from "@/components/mobile/bets/new/betParlayStatus";

import betSingleMMOModal from "@/components/mobile/bets/mmo/betSingleModal";
import betSingleMMOStatus from "@/components/mobile/bets/mmo/betSingleStatus";
import betParlayMMOModal from "@/components/mobile/bets/mmo/betParlayModal";
import betParlayMMOStatus from "@/components/mobile/bets/mmo/betParlayStatus";

import minigamesModal from "@/components/mobile/minigamesModal";
import timeMachineModal from "@/components/mobile/timeMachine/timeMachineModal";



// import betResultModal from "@/components/mobile/bets/betResultModal";
import searchModal from "@/components/mobile/searchModal";
import leagueModal from "@/components/mobile/leagueModal";
import nicknameModal from "@/components/mobile/account/nicknameModal";
import passwordModal from "@/components/mobile/account/passwordModal";
import languageModal from "@/components/mobile/account/languageModal";
import oddsTypeModal from "@/components/mobile/account/oddsTypeModal";
import defaultEventSortingModal from "@/components/mobile/account/defaultEventSortingModal";
import allSportsModal from "@/components/mobile/account/allSportsModal";
import drawer from "@/components/mobile/drawer";
import topButton from "@/components/mobile/topButton";
// import glassTimer from "@/components/mobile/glassTimer";
import { NEW_UI_LOBBY_MODAL_SEEN_KEY, UUSLOT_PROMO_MODAL_SEEN_KEY } from "@/sessionUiKeys";
import acc from "@/library/_xhr-account";

export default {  
  components: {
    eventengine,
    minigamesModal,
    floating,
    betSingleModal,
    betSingleStatus,
    betParlayModal,
    betParlayStatus,
    // betResultModal,
    betSingleMMOModal,
    betSingleMMOStatus,
    betParlayMMOModal,
    betParlayMMOStatus,
    searchModal,
    leagueModal,
    nicknameModal,
    passwordModal,
    languageModal,
    oddsTypeModal,
    defaultEventSortingModal,
    allSportsModal,
    drawer,
    topButton,
    timeMachineModal,
    // glassTimer
  },
  data() {
    return {
      changingToModern: false,
      // showGlassTimer: false,
      showUuslotPromoFrame: false,
      uuslotPromoUrl: "https://l22campaign.com/campaign/9th-anniversary/en"
    };
  },
  computed: {
    wcMode() {
      return config.wcMode;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    fifaCampaignBannerImage() {
      const suffix = this.$store.getters.language === "cn" ? "cn" : "en";
      return `images/FIFA June26 Campaign Banner_480x270_${suffix}.jpg`;
    }
  },
  watch: {
    $route() {
      this.maybeShowNewUiLobbyModal();
    }
  },
  mounted() {
    this._onNewUiModalShown = () => {
      try {
        sessionStorage.setItem(NEW_UI_LOBBY_MODAL_SEEN_KEY, "1");
      } catch (e) {}
      // this.showGlassTimer = true;
    };
    this._onNewUiModalHidden = () => {
      // this.showGlassTimer = false;
      if (!this.changingToModern) {
        this.maybeShowUuslotPromoModal();
      }
    };
    this._onUuslotPromoModalShown = () => {
      try {
        sessionStorage.setItem(UUSLOT_PROMO_MODAL_SEEN_KEY, "1");
      } catch (e) {}
    };
    this._onUuslotPromoModalHidden = () => {
      this.showUuslotPromoFrame = false;
    };
    $("#new-ui").on("shown.bs.modal", this._onNewUiModalShown);
    $("#new-ui").on("hidden.bs.modal", this._onNewUiModalHidden);
    $("#uuslot-promo").on("shown.bs.modal", this._onUuslotPromoModalShown);
    $("#uuslot-promo").on("hidden.bs.modal", this._onUuslotPromoModalHidden);
    this.maybeShowNewUiLobbyModal();
  },
  beforeDestroy() {
    $("#new-ui").off("shown.bs.modal", this._onNewUiModalShown);
    $("#new-ui").off("hidden.bs.modal", this._onNewUiModalHidden);
    $("#uuslot-promo").off("shown.bs.modal", this._onUuslotPromoModalShown);
    $("#uuslot-promo").off("hidden.bs.modal", this._onUuslotPromoModalHidden);
  },
  methods: {
    maybeShowNewUiLobbyModal() {
      if (this.$route.name !== "lobby" || !this.$store.getters.isLoggedIn) return;
      // #new-ui is only rendered in wcMode. Without it, hidden.bs.modal never fires,
      // so the UUSLOT promo (which used to wait on that event) must open on its own.
      if (!this.wcMode) {
        this.maybeShowUuslotPromoModal();
        return;
      }
      try {
        if (sessionStorage.getItem(NEW_UI_LOBBY_MODAL_SEEN_KEY)) {
          this.maybeShowUuslotPromoModal();
          return;
        }
      } catch (e) {
        return;
      }
      this.$nextTick(() => {
        const $modal = $("#new-ui");
        if (!$modal.length) {
          this.maybeShowUuslotPromoModal();
          return;
        }
        $modal.modal("show");
      });
    },
    maybeShowUuslotPromoModal() {
      if (this.$route.name !== "lobby" || !this.$store.getters.isLoggedIn) return;
      try {
        if (sessionStorage.getItem(UUSLOT_PROMO_MODAL_SEEN_KEY)) return;
      } catch (e) {
        return;
      }
      this.showUuslotPromoFrame = true;
      this.$nextTick(() => {
        $("#uuslot-promo").modal("show");
      });
    },
    onGlassTimerComplete() {
      this.changeView("modern");
    },
    openFifaCampaignBanner() {
      window.open("https://q.me-qr.com/iaylbdo3", "_blank");
    },
    changeView(e) {
      if (this.changingToModern) return;
      const modernParam = e === "modern" ? "&v=m" : "";
      const url = acc.changeView(e) + "?u=" + this.$store.getters.accountId + "&st=" + this.$store.getters.sessionToken + modernParam;
      if (e === "modern") {
        this.changingToModern = true;
        $("#new-ui").modal("hide");
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              window.location.href = url;
            });
          });
        });
      } else {
        window.location.href = url;
      }
    },
  }
};
</script>

<style scoped>
.new-ui-fullscreen-loading {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}
.new-ui-switch-inner {
  text-align: center;
  color: #fff;
  padding: 1rem;
  max-width: 90%;
}
.new-ui-switch-spinner {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}
.new-ui-switch-text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}
#uuslot-promo .promo-frame {
  display: block;
  width: 100%;
  height: 75vh;
  border: 0;
  background: #fff;
}
</style>
